import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { CompareList } from "../../types";

import CompareRowText from "./CompareRowText";
import CompareRowFlag from "./CompareRowFlag";
import CompareRowBoolean from "./CompareRowBoolean";
import { useTranslation } from "react-i18next";

const PlayerCompare = React.memo(({ compareUsersList }: { compareUsersList: any }) => {
  const { t } = useTranslation();

  const renderCompareRow = useCallback((item: CompareList, index: number, list: CompareList[]) => {
    const { label, key, type } = item;
    const totalRows: number = list.length;
    const isLastRow: boolean = index + 1 === totalRows;

    switch (type) {
      case "text":
        return <CompareRowText compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "flag":
        return <CompareRowFlag compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "boolean":
        return (
          <CompareRowBoolean compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />
        );
      default:
        return null;
    }
  }, []);

  const playerOverViewList: CompareList[] = [
    { label: t("components.compare.age"), key: "age", type: "text" },
    { label: t("components.compare.weight"), key: "weight", type: "text" },
    { label: t("components.compare.height"), key: "height", type: "text" },
    { label: t("components.compare.strongFoot"), key: "strongFoot", type: "text" },
    { label: t("components.compare.primaryPosition"), key: "primaryPosition", type: "text" },
    { label: t("components.compare.otherPosition"), key: "otherPosition", type: "text" },
  ];

  const nationalityAndLocationList: CompareList[] = [
    { label: t("components.compare.nationality"), key: "nationality", type: "flag" },
    { label: t("components.compare.residenceCountry"), key: "country", type: "flag" },
  ];

  const professionalCredentialList: CompareList[] = [
    { label: t("components.compare.hasAnAgent"), key: "hasAgent", type: "boolean" },
    { label: t("components.compare.hasFootballExperience"), key: "hasFootballExperience", type: "boolean" },
    { label: t("components.compare.hasCertificationOrLicense"), key: "hasCertificate", type: "boolean" },
  ];

  const skillsList: CompareList[] = [{ label: t("components.compare.skills"), key: "skills", type: "text" }];

  const playingLevelList: CompareList[] = [
    { label: t("components.compare.playingLevel"), key: "playingLevel", type: "text" },
  ];

  return (
    <>
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.playerOverview")}
      </Typography>
      {playerOverViewList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.nationalityAndLocation")}
      </Typography>
      {nationalityAndLocationList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.professionalCredential")}
      </Typography>
      {professionalCredentialList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.skills")}
      </Typography>
      {skillsList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.playingLevel")}
      </Typography>
      {playingLevelList.map(renderCompareRow)}
    </>
  );
});

export default PlayerCompare;
